export default __webpack_public_path__ + "static/media/formosan-7.e64bb0e6.jpg";